import { Component, Input, OnInit } from '@angular/core';
import {
  BalanceQuery,
  Barcode,
  BarcodeQuery,
  BarcodeService,
  config,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  SeatingDetail,
  SeatingDetailQuery,
} from '@fgb/core';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit {
  @Input() memberId: string;
  @Input() primaryTheme: boolean = false;
  @Input() showCashBackToggle: boolean = false;
  @Input() showWallet: boolean = true;
  @Input() showBarcode: boolean = true;
  @Input() version: number = 2;
  barcode$: Observable<Barcode>;
  card$: Observable<MemberCard | undefined>;
  member$: Observable<MemberDetails | undefined>;
  seatingDetail$: Observable<SeatingDetail | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  ecash$: Observable<number | undefined>;
  pointsBalance$: Observable<number | undefined>;

  loading$: Observable<boolean>;
  combined$: Observable<any>;

  constructor(
    private barcodeService: BarcodeService,
    private barcodeQuery: BarcodeQuery,
    private balanceQuery: BalanceQuery,
    private memberCardQuery: MemberCardQuery,
    private memberDetailsQuery: MemberQuery,
    private seatingDetailQuery: SeatingDetailQuery,
    private memberQuery: MemberQuery
  ) {}

  ngOnInit() {
    this.seatingDetail$ = this.seatingDetailQuery.selectCurrentSeatingDetails();
    this.barcodeService.fetchBarcode().toPromise();
    this.barcode$ = this.barcodeQuery.select();
    this.member$ = this.memberDetailsQuery.selectMemberDetails();
    this.card$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);

    this.loading$ = this.barcode$.pipe(
      map((barcode) => !barcode),
      startWith(true)
    );
  }
}
